import React from 'react';
import { useTranslation } from 'react-i18next';
import './FaqSection.scss';

interface FaqItemProps {
  question: string;
  answer: string;
}

const FaqItem: React.FC<FaqItemProps> = ({ question, answer }) => {
  return (
    <div className="faq-item">
      <h3 className="faq-question">{question}</h3>
      <p className="faq-answer">{answer}</p>
    </div>
  );
};

const FaqSection: React.FC = () => {
  const { t } = useTranslation();

  const faqs = t('faq', { returnObjects: true }) as Array<{
    question: string;
    answer: string;
  }>;

  return (
    <section className="faq-section">
      <div className="container">
        <h2 className="section-title">{t('faqTitle')}</h2>
        <div className="faq-grid">
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
